import React from "react";
import { connect } from "react-redux";

import { nombreProductoGM, getNumPoliza } from "../common/logica";
import { getFechasVigencia } from "./logicaFechas";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza
	};
};

class GeneralesPoliza extends React.Component {
	render() {
		let imgPoliza, border = "", ramo = "", estatus = "";
		let fechas = getFechasVigencia(this.props.poliza);

		if (this.props.poliza.generales.cveEstatus == "A" || this.props.poliza.generales.cveEstatus == "V" || this.props.poliza.generales.cveEstatus == 1) {
			estatus = "VIGENTE";
		}

		switch (this.props.poliza.generales.cveRamo) {
		case "A":
			imgPoliza = require("../img/circle-poliza.svg");
			border = "4px solid #ff6f20";
			ramo = "Autos";
			break;
		case "G":
			// imgPoliza = require("../img/circle-poliza-gm.svg");
			imgPoliza = require("../img/circle-poliza.svg");
			border = "4px solid #0352ff";
			ramo = "Gastos Médicos Mayores";
			break;
		case "D":
			// imgPoliza = require("../img/circle-poliza-danios.svg");
			imgPoliza = require("../img/circle-poliza.svg");
			border = "4px solid #7045f1";
			ramo = "Daños";
			break;
		case "V":
			// imgPoliza = require("../img/circle-poliza-vida.svg");
			imgPoliza = require("../img/circle-poliza.svg");
			border = "4px solid #3aba4a";
			ramo = "Vida";
			break;
		}

		return <div className="card">
			<i><img src={ imgPoliza } alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Póliza</span>
			<ul className="list-divider mt-25">
				<li className="clearfix">
					<div className="pull-left">
						<p><b>No. Póliza</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="poliza">{getNumPoliza(this.props.poliza)}</p>
						</div>
					</div>
				</li>
				{ (this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05") &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Segmento</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="segmento">Grupo</p>
						</div>
					</div>
				</li>
				}
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Ramo</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="ramo">{ ramo }</p>
						</div>
					</div>
				</li>
				{ this.props.poliza.generales.cveRamo != "V" && this.props.poliza.generales.cveClasificacionSeguro != "06" && this.props.poliza.generales.cveClasificacionSeguro != "05" &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Estatus</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="estatus">{ estatus }</p>
						</div>
					</div>
				</li>
				}
				<li className="clearfix">
					<div className="pull-left">
						<p><b>{ ( this.props.poliza.generales.cveRamo == "G" ) ? ("Plan") : ("Producto") }</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
						{ this.props.poliza.generales.cveRamo == "G" &&
							<p name="paquete">{ nombreProductoGM(this.props.poliza) }</p>
						}
						{ this.props.poliza.generales.cveRamo == "A" &&
							<p name="paquete">{ this.props.poliza.generales.productoNegocio }</p>
						}
						{ (this.props.poliza.generales.cveRamo == "V" || this.props.poliza.generales.cveRamo == "D")  &&
							<p name="paquete">{ this.props.poliza.generales.productoComercial }</p>
						}
						</div>
					</div>
				</li>
				{ this.props.poliza.generales.cveRamo == "G" &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Círculo Médico</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="circuloMedico">{ this.props.poliza.generales.circuloMedico }</p>
						</div>
					</div>
				</li>
				}
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Inicio de vigencia</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="inicioVigencia">{ fechas.inicio }</p>
						</div>
					</div>
				</li>
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Fin de vigencia</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="finVigencia">{ fechas.fin }</p>
						</div>
					</div>
				</li>
				{ this.props.poliza.generales.cveRamo == "A" && (this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05") &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Referencia I</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="referencia1">{ this.props.poliza.generales.referencia1 }</p>
						</div>
					</div>
				</li>
				}
				{ this.props.poliza.generales.cveRamo == "V" && (this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05") &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Referencia I</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="referencia1">{ this.props.poliza.generales.referencia1 }</p>
						</div>
					</div>
				</li>
				}
				{ this.props.poliza.generales.cveRamo == "V" && (this.props.poliza.generales.cveClasificacionSeguro == "06" || this.props.poliza.generales.cveClasificacionSeguro == "05") &&
				<li className="clearfix">
					<div className="pull-left">
						<p><b>Referencia II</b></p>
					</div>
					<div className="pull-right">
						<div className="gray-text texto15">
							<p name="referencia2">{ this.props.poliza.generales.referencia2 }</p>
						</div>
					</div>
				</li>
				}
			</ul>
		</div>
	}
}

export default connect(mapState)(GeneralesPoliza);



// WEBPACK FOOTER //
// ./src/home/generales.cmpt.js